import "ress/ress.css";
import React from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import { InitStyle } from "~/atoms/InitStyle";
import ogpPng from "~/images/ogp.png";
import "~/utils/styledJsx";
import { LpRpo01PageHeader } from "~/molecules/lp/rpo/01/LpRpo01PageHeader";
import { LpRop01PageFooter } from "~/molecules/lp/rpo/01/LpRpo01PageFooter";

type Props = {
  title?: string;
  children: React.ReactNode;
  ogpDescription?: string;
  ogpImageUrl?: string;
  ogpTitle?: string;
  noindex?: boolean;
  canonicalUrl?: string;
  hideHeaderDownloadButton?: boolean;
};

export const LpRpo01PageLayout: React.FC<Props> = ({
  title,
  children,
  ogpDescription,
  ogpImageUrl,
  ogpTitle,
  noindex,
  canonicalUrl,
  hideHeaderDownloadButton = false,
}) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
        }
      }
    }
  `);

  const pageTitle = title ? title : site.siteMetadata.title;
  const sharedOgpTitle = ogpTitle ? ogpTitle : pageTitle;
  const sharedOgpDescription = ogpDescription || site.siteMetadata.description;
  const meta = [
    {
      name: `description`,
      content: sharedOgpDescription,
    },
    {
      property: `og:title`,
      content: sharedOgpTitle,
    },
    {
      property: `og:description`,
      content: sharedOgpDescription,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      property: `og:image`,
      content: ogpImageUrl ? ogpImageUrl : `${ogpPng}`,
    },
    {
      property: `fb:app_id`,
      content: `2220166827995808`,
    },
    {
      name: `twitter:card`,
      content: `summary_large_image`,
    },
    {
      name: `twitter:creator`,
      content: site.siteMetadata.author,
    },
    {
      name: `twitter:title`,
      content: sharedOgpTitle,
    },
    {
      name: `twitter:description`,
      content: ogpDescription,
    },
    {
      name: `twitter:image`,
      content: ogpImageUrl ? ogpImageUrl : `${ogpPng}`,
    },
    {
      httpEquiv: `content-language`,
      content: "ja",
    },
    noindex ? { name: `robots`, content: `noindex` } : {},
  ];
  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: "ja",
        }}
        meta={meta}
      >
        <title>{pageTitle}</title>
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      </Helmet>
      <InitStyle />
      <LpRpo01PageHeader hideDownloadButton={hideHeaderDownloadButton} />
      <main>{children}</main>
      <LpRop01PageFooter />
    </>
  );
};
